module.exports = __webpack_public_path__ + "images/category_lp/common/icon-japan-map@2x_b443840e30d8fcb018ee0890935fd697.png";